(() => {
  const labels = document.getElementById('almila-media-labels');
  if (!labels) return;

  const titles = [
    ['thumbnails', 'toolbarButtons', 'thumbs'],
    ['zoomIn', 'toolbarButtons', 'zoomIn'],
    ['zoomOut', 'toolbarButtons', 'zoomOut'],
    ['play', 'toolbarButtons', 'slideshow', 'start'],
    ['pause', 'toolbarButtons', 'slideshow', 'pause'],
    ['fullscreenEnter', 'toolbarButtons', 'fullscreen', 'enter'],
    ['fullscreenExit', 'toolbarButtons', 'fullscreen', 'exit'],
    ['close', 'toolbarButtons', 'close'],
    ['previous', 'slideButtons', 'previous'],
    ['next', 'slideButtons', 'next']
  ];

  function configure() {
    for (const name of ['gallery', 'lightbox-basic']) {
      const props = window.fsLightboxInstances?.[name]?.props;
      if (!props) continue;
      for (const [key, ...path] of titles) {
        const button = path.reduce((value, part) => value?.[part], props);
        const title = labels.dataset[key];
        if (button && title) button.title = title;
      }
    }
  }

  configure();
  document.addEventListener('shopify:section:load', () => queueMicrotask(configure));
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-fslightbox]')) configure();
  }, true);
})();

(() => {
  const labels = document.getElementById('almila-media-labels');
  if (!labels) return;

  const bound = new WeakSet();
  const numberToken = '__ALMILA_NUMBER__';
  const currentToken = '__ALMILA_CURRENT__';
  const totalToken = '__ALMILA_TOTAL__';
  const translations = labels.dataset;

  function getInfo(slider) {
    try {
      return typeof slider?.getInfo === 'function' ? slider.getInfo() : null;
    } catch {
      return null;
    }
  }

  function supported(info) {
    return info?.container?.isConnected && info.container.matches('.js-slides') &&
      info.container.closest('.js-product-slideshow') && info.isOn !== false &&
      info.items === 1 && Number.isInteger(info.slideCount) && info.slideCount > 0 &&
      Number.isInteger(info.displayIndex) && info.displayIndex > 0 && info.displayIndex <= info.slideCount;
  }

  function setLabel(element, value) {
    if (element && value && element.getAttribute('aria-label') !== value) element.setAttribute('aria-label', value);
  }

  function update(slider) {
    const info = getInfo(slider);
    if (!supported(info)) return;
    setLabel(info.controlsContainer, translations.carouselNavigation);
    setLabel(info.navContainer, translations.carouselPagination);
    if (info.navItems && translations.carouselSlide && translations.carouselCurrent) {
      Array.from(info.navItems).forEach((item, index) => {
        const template = index === info.navCurrentIndex ? translations.carouselCurrent : translations.carouselSlide;
        setLabel(item, template.split(numberToken).join(String(index + 1)));
      });
    }

    const outer = info.container.closest('.tns-outer');
    if (!outer || !info.container.closest('.js-product-slideshow').contains(outer)) return;
    const current = outer.querySelector('.tns-liveregion .current');
    const before = current?.previousSibling;
    const after = current?.nextSibling;
    const template = translations.carouselPosition;
    if (!template || before?.nodeType !== 3 || after?.nodeType !== 3) return;
    const parts = template.split(currentToken);
    if (parts.length !== 2 || template.split(totalToken).length !== 2) return;
    const prefix = parts[0].split(totalToken).join(String(info.slideCount));
    const suffix = parts[1].split(totalToken).join(String(info.slideCount));
    if (before.data !== prefix) before.data = prefix;
    if (after.data !== suffix) after.data = suffix;
    const position = String(info.displayIndex);
    if (current.textContent !== position) current.textContent = position;
  }

  function bindSlider(slider) {
    if (!slider || typeof slider.getInfo !== 'function' || typeof slider.events?.on !== 'function' || !supported(getInfo(slider))) return;
    update(slider);
    if (bound.has(slider)) return;
    bound.add(slider);
    let pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        update(slider);
      });
    }
    slider.events.on('indexChanged', schedule);
    slider.events.on('newBreakpointEnd', schedule);
  }

  window.AlmilaMediaLabels = { bindSlider };
})();

// Every other tiny-slider (recommendations, curated and home carousels) and every SlimSelect list: their built-in
// English accessible names and live-region text, in the page's language. The gallery above keeps its own handling;
// both write the same values, so they never undo each other.
(() => {
  const labels = document.getElementById('almila-media-labels');
  if (!labels) return;
  const t = labels.dataset;
  const fixed = {
    'Carousel Navigation': t.carouselNavigation,
    'Carousel Pagination': t.carouselPagination,
    'choose-option': t.optionList,
    Search: t.optionSearch
  };
  const page = /^Carousel Page (\d+)( \(Current Slide\))?$/;
  const fill = (template, token, value) => template && template.split(token).join(value);

  function relabel(el) {
    const label = el.getAttribute('aria-label');
    if (!label) return;
    const match = page.exec(label);
    const value = match ? fill(match[2] ? t.carouselCurrent : t.carouselSlide, '__ALMILA_NUMBER__', match[1]) : fixed[label];
    if (value && value !== label) el.setAttribute('aria-label', value);
  }

  // tiny-slider writes "slide <span class="current">1 to 3</span>  of 7" and updates only the span.
  function region(el) {
    const current = el.querySelector('.current');
    const before = current?.previousSibling;
    const after = current?.nextSibling;
    const template = t.carouselPosition;
    if (!current || !template || before?.nodeType !== 3 || after?.nodeType !== 3) return;
    const total = (/(\d+)\s*$/.exec(after.data) || [])[1];
    const parts = template.split('__ALMILA_CURRENT__');
    if (!total || parts.length !== 2) return;
    const prefix = parts[0].split('__ALMILA_TOTAL__').join(total);
    const suffix = parts[1].split('__ALMILA_TOTAL__').join(total);
    const position = current.textContent.replace(/\s+to\s+/, '–');
    if (before.data !== prefix) before.data = prefix;
    if (after.data !== suffix) after.data = suffix;
    if (current.textContent !== position) current.textContent = position;
  }

  function sweep(root) {
    if (!(root instanceof Element)) return;
    root.querySelectorAll('[aria-label]').forEach(relabel);
    if (root.hasAttribute('aria-label')) relabel(root);
    root.querySelectorAll('.tns-liveregion').forEach(region);
    if (root.matches('.tns-liveregion')) region(root);
    root.querySelectorAll('.ss-search input[placeholder="Search"]').forEach(input => { if (t.optionSearch) input.placeholder = t.optionSearch; });
  }

  function start() {
    sweep(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') relabel(record.target);
        else if (record.type === 'characterData') {
          const live = record.target.parentElement?.closest('.tns-liveregion');
          if (live) region(live);
        } else {
          record.addedNodes.forEach(node => {
            if (node.nodeType === 1) sweep(node);
            else if (node.nodeType === 3) {
              const live = node.parentElement?.closest('.tns-liveregion');
              if (live) region(live);
            }
          });
        }
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
